import { createActions, asyncAction } from '../helpers/redux';
import { schema, normalize } from 'normalizr';

import { ToastActions } from './toast';

// const tagsSchema = new schema.Entity('tags');
const typesSchema = new schema.Entity('types');

const relationshipSchema = new schema.Entity('relationships', {
  type: typesSchema,
});
// const elementsSchema = new schema.Entity('elements', {
//   type: typesSchema,
// });
const elementSchema = new schema.Entity('elements');
const tagSchema = new schema.Entity('tags');

const objectTagsSchema = new schema.Entity(
  'objectTags',
  {
    tag: tagSchema,
  },
  {
    idAttribute: tag => {
      return `${tag.taggable_id}-${tag.taggable_type}-${tag.tag_id}`;
    },
  },
);

elementSchema.define({
  type: typesSchema,
  objectTags: [objectTagsSchema],
  children: [elementSchema],
  relationships: [relationshipSchema],
});

// const objectsTagsSchema = new schema.Entity(
//   'tags',
//   {},
//   { idAttribute: 'tag_id' },
// );

export const TagActions = createActions({
  // setTagIdFilter(tagId) {
  //   return { tagId: tagId };
  // },

  // appendTagIdToFilter(tagId) {
  //   return { tagId: tagId };
  // },

  // @asyncAction()
  // async tagSearch(projectId, tag) {
  //   return ({ client, getState }) => {
  //     return client
  //       .get(`/projects/${projectId}/tags/search`, {
  //         qs: {
  //           tag: tag,
  //         },
  //       })
  //       .then(response => {
  //         return normalize(response, [tagsSchema]);
  //       });
  //   };
  // },

  // @asyncAction()
  // async deleteTagFromProject(projectId, tagId) {
  //   return ({ client }) => {
  //     return client
  //       .delete(`/projects/${projectId}/tags/${tagId}`)
  //       .then(response => {
  //         return {
  //           projectId,
  //           tagId,
  //         };
  //       });
  //   };
  // },

  // @asyncAction()
  // async getProjectTags(projectId) {
  //   return ({ client, getState }) => {
  //     return client.get(`/projects/${projectId}/tags`).then(response => {
  //       return normalize(response, [tagsSchema]);
  //     });
  //   };
  // },

  // @asyncAction()
  // async getTaggedObjectsCount(projectId, tagIds) {
  //   return ({ client, getState }) => {
  //     return client
  //       .post(`/tags/count`, {
  //         body: {
  //           projectId: projectId,
  //           tagIds: tagIds,
  //         },
  //       })
  //       .then(response => {
  //         return response;
  //       });
  //   };
  // },

  // @asyncAction()
  // async getObjectsByTags(projectId, tagIds, type) {
  //   return ({ client, getState }) => {
  //     return client
  //       .post(`/tags/objects`, {
  //         body: {
  //           projectId: projectId,
  //           tagIds: tagIds,
  //           type: type ? type : 'Element',
  //         },
  //         qs: {
  //           offset: null,
  //           sortBy: getState().tagTabPage.getIn(['default', 'sortBy']),
  //           direction: getState().tagTabPage.getIn(['default', 'direction']),
  //         },
  //       })
  //       .then(response => {
  //         let schema;
  //         switch (type) {
  //           case 'Element':
  //             schema = elementsSchema;
  //             break;
  //           case 'Relationship':
  //             schema = relationshipSchema;
  //             break;
  //           default:
  //             schema = elementsSchema;
  //             break;
  //         }
  //         return normalize(response, [schema]);
  //       });
  //   };
  // },

  // @asyncAction()
  // async loadMoreFiltered(projectId, tagIds, type) {
  //   return ({ client, getState }) => {
  //     return client
  //       .post(`/tags/objects`, {
  //         body: {
  //           projectId: projectId,
  //           tagIds: tagIds,
  //           type: type ? type : 'Element',
  //         },
  //         qs: {
  //           offset: getState().tagTabPage.getIn(['default', 'results']).size,
  //           sortBy: getState().tagTabPage.getIn(['default', 'sortBy']),
  //           direction: getState().tagTabPage.getIn(['default', 'direction']),
  //         },
  //       })
  //       .then(response => {
  //         return response;
  //       });
  //   };
  // },

  // @asyncAction()
  // async getObjectsByTagId(id) {
  //   return ({ client }) => {
  //     return client.get(`/tags/${id}`).then(response => {
  //       return normalize(response, [objectsTagsSchema]);
  //     });
  //   };
  // },

  // @asyncAction()
  // async untagObject(object) {
  //   return ({ client }) => {
  //     return client
  //       .post(`/tags/untag`, {
  //         body: object,
  //       })
  //       .then(response => {
  //         return object;
  //       });
  //   };
  // },

  // @asyncAction()
  // async getTagsByIds(projectId, tagIds, type) {
  //   return ({ client, getState }) => {
  //     return client
  //       .post(`/tags/batch`, {
  //         body: {
  //           projectId: projectId,
  //           tagIds: tagIds,
  //           type: type ? type : 'Element',
  //         },
  //       })
  //       .then(response => {
  //         return normalize(response, [tagsSchema]);
  //       });
  //   };
  // },

  // @asyncAction()
  // async getElementTags(id) {
  //   return ({ client }) => {
  //     return client.get(`/elements/${id}/tags`).then(response => {
  //       return {
  //         id,
  //         data: normalize(response, [tagsSchema]),
  //       };
  //     });
  //   };
  // },

  // @asyncAction()
  // async getProjectElementsTags(id) {
  //   return ({ client }) => {
  //     return client.get(`/projects/${id}/tags`).then(response => {
  //       return response;
  //     });
  //   };
  // },

  @asyncAction()
  async tagObject(obj) {
    return ({ client, dispatch }) => {
      return client
        .put(`/tags`, {
          body: obj,
        })
        .then(response => {
          return normalize(response, [elementSchema]);
        })
        .catch(err => {
          dispatch(ToastActions.createToast('Cycle name already taken.'));
          throw err;
        });
    };
  },

  // @asyncAction()
  // async creatProjectTag(obj) {
  //   return ({ client, getState }) => {
  //     const projectId = getState().projects.get('currentProjectId');
  //
  //     return client
  //       .put(`/projects/${projectId}/tags`, {
  //         body: obj,
  //       })
  //       .then(response => {
  //         return normalize(response, [objectsTagsSchema]);
  //       });
  //   };
  // },

  // @asyncAction()
  // async untagElement(elementId, tagId) {
  //   return ({ client }) => {
  //     return client
  //       .delete(`/elements/${elementId}/tags/${tagId}`)
  //       .then(response => {
  //         return {
  //           elementId,
  //           tagId,
  //         };
  //       });
  //   };
  // },
});



// WEBPACK FOOTER //
// ./src/actions/tag.js